import React from 'react';
import Section, { FadeIn } from './ui/Section';
import SafeIcon from '../common/SafeIcon';

const Urgency = () => {
  return (
    <Section id="download-form" className="bg-brand-gray relative overflow-hidden">
      {/* Decorative background */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none opacity-5">
        <div className="absolute w-96 h-96 bg-brand-dark rounded-full mix-blend-multiply filter blur-3xl -top-10 -left-10"></div>
        <div className="absolute w-96 h-96 bg-brand-yellow rounded-full mix-blend-multiply filter blur-3xl top-40 right-10"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          
          <FadeIn>
            <h2 className="text-4xl md:text-5xl font-extrabold mb-6 tracking-tight">
              Get Clarity <span className="text-brand-yellow bg-brand-dark px-2 py-1 rounded-sm shadow-sm inline-block transform -rotate-2">Tonight</span>
            </h2>
            
            <p className="text-xl text-gray-700 mb-8">
              Every day you spend guessing is another day of:
            </p>
            
            <ul className="space-y-4 mb-8">
              {["Fights about \"nothing\"", "Nights analyzing texts", "Love lost to misunderstanding"].map((item, i) => (
                <li key={i} className="flex items-center gap-3 text-lg font-medium text-brand-dark">
                  <SafeIcon name="AlertCircle" className="text-red-500 shrink-0" />
                  {item}
                </li>
              ))}
            </ul>

            <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm mb-8">
              <p className="font-bold text-brand-dark mb-4 uppercase tracking-wider text-sm">For zero dollars, you get:</p>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <SafeIcon name="Check" className="text-green-500 mt-1" />
                  <span>10 translations that prevent fights</span>
                </li>
                <li className="flex items-start gap-3">
                  <SafeIcon name="Check" className="text-green-500 mt-1" />
                  <span>Exact scripts for what to say back</span>
                </li>
                <li className="flex items-start gap-3">
                  <SafeIcon name="Check" className="text-green-500 mt-1" />
                  <span>The decoder ring nobody gave you</span>
                </li>
              </ul>
            </div>

            <p className="text-gray-600 font-medium flex items-center gap-2">
              <SafeIcon name="Users" className="text-brand-yellow" />
              Join 10,000+ people who stopped guessing.
            </p>
          </FadeIn>

          <FadeIn delay={0.2}>
            <div className="bg-brand-dark text-white rounded-2xl p-8 md:p-10 shadow-2xl relative">
              <div className="absolute -top-4 -right-4 bg-brand-yellow text-brand-dark font-bold px-4 py-1 rounded-full shadow-lg transform rotate-3 z-20">
                100% FREE
              </div>
              
              <h3 className="text-2xl font-bold mb-2">Where should we send your guide?</h3>
              <p className="text-gray-400 mb-6 text-sm">Instant email delivery. PDF format.</p>
              
              <div className="relative w-full bg-white rounded-lg overflow-hidden" style={{ height: '480px' }}>
                <iframe
                  src="https://link.nordiccrm.ca/widget/form/sYiFRLmfhGEwVEe8aVik"
                  style={{ width: '100%', height: '100%', border: 'none', borderRadius: '8px' }}
                  id="inline-sYiFRLmfhGEwVEe8aVik"
                  data-layout="{'id':'INLINE'}"
                  data-trigger-type="alwaysShow"
                  data-trigger-value=""
                  data-activation-type="alwaysActivated"
                  data-activation-value=""
                  data-deactivation-type="neverDeactivated"
                  data-deactivation-value=""
                  data-form-name="Lead Magnet Form"
                  data-scrollbar="yes"
                  data-auto-height="false"
                  data-origin="https://link.nordiccrm.ca"
                  title="Lead Magnet Form"
                ></iframe>
              </div>

              <div className="mt-6 flex flex-col items-center gap-2 text-xs text-center text-gray-500">
                <span className="flex items-center gap-1.5 justify-center">
                  <SafeIcon name="Lock" className="w-3 h-3" /> Your information is secure. We never share your email.
                </span>
                <span>We never spam. Unsubscribe anytime.</span>
              </div>
            </div>
          </FadeIn>

        </div>
      </div>
    </Section>
  );
};

export default Urgency;